import React from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, Tooltip, LabelList } from "recharts";
import SubscalePlots from "./SubscalePlots";

const ThemeBarChart = ({ themeScores, subscaleScores }) => {
    if (!themeScores || themeScores.length === 0) return <p className="text-white">No data available.</p>;

    const colors = {
        "Investigative": "#DC143C",
        "Realistic": "#9370DB",
        "Conventional": "#FFA500",
        "Social": "#90EE90",
        "Artistic": "#FF7F50",
        "Enterprising": "#87CEEB",
    };

    // Sort themes from highest to lowest score
    const sortedThemes = [...themeScores].sort((a, b) => b.score - a.score);

    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart layout="vertical" data={sortedThemes} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
                <XAxis type="number" domain={[0, 100]} tick={{ fill: "#ffffff" }} />
                <YAxis type="category" dataKey="theme" tick={{ fill: "#ffffff" }} width={120} />
                <Tooltip
                    content={<CustomTooltip subscaleScores={subscaleScores} />} // ✅ Pass Subscale Data
                    cursor={{ fill: "rgba(255, 255, 255, 0.1)" }}
                />
                <Bar dataKey="score">
                    {sortedThemes.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colors[entry.theme] || "#999"} />
                    ))}
                    <LabelList
                        dataKey="score"
                        position="right"
                        fill="white"
                        fontSize={14}
                        formatter={(value) => Math.round(value)}
                    />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

const CustomTooltip = ({ active, payload, subscaleScores }) => {
    if (!active || !payload || payload.length === 0) return null;

    const selectedTheme = payload[0].payload.theme;
    const filteredSubscales = subscaleScores.filter((s) => s.theme === selectedTheme);

    return (
        <div
            className="bg-gray-900 p-4 rounded-lg shadow-lg text-white w-[500px] z-50"
            style={{
                position: "fixed", // Fixed position for centering
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                maxWidth: "90vw", // Prevents overflow on narrow screens
                zIndex: 1000,
            }}
        >
            <h3 className="font-bold text-center text-lg mb-2">{selectedTheme} Subscales</h3>
            {filteredSubscales.length > 0 ? (
                <div className="w-100 h-100">
                    <SubscalePlots theme={selectedTheme} subscaleScores={filteredSubscales} />
                </div>
            ) : (
                <p className="text-center text-gray-300">No subscale data available</p>
            )}
        </div>
    );
};


export default ThemeBarChart;
